import {customAttribute, inject, bindable, bindingMode, TaskQueue, DOM} from "aurelia-framework";
import {equalsOrChildOf} from "../../tools/dom";
import {noop} from "lodash";

@inject(DOM.Element, TaskQueue)
@customAttribute("out-click")
export class OutClick {

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) active = false;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) click = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) childCheck = true;

  /** @type {Element} */
  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) except = null;

  __clickListener: EventListener;

  constructor(public element: Element, public taskQueue: TaskQueue) {
  }

  bind() {
    this.activeChanged(this.active);
  }

  unbind() {
    this.removeListener();
  }

  activeChanged(newValue) {
    if (newValue) {
      DOM.addEventListener("click", this.__clickListener = e => {
        if (this.canHandle(e)) {
          this.taskQueue.queueMicroTask(this.click);
          this.removeListener();
        }
      }, true);
    } else {
      this.removeListener();
    }
  }

  canHandle(event) {
    if (this.except && equalsOrChildOf(this.except, event.target)) {
      return false;
    } else {
      return !this.childCheck || !equalsOrChildOf(this.element, event.target);
    }
  }

  removeListener() {
    if (this.__clickListener) {
      DOM.removeEventListener("click", this.__clickListener, true);
      this.__clickListener = null;
    }
    this.active = false;
  }

}
